import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withAsyncPaginate } from 'react-select-async-paginate';
import Select, { components } from '@atlaskit/select';
import client from '../../../services/graphql';

import { Container, TextNoResults, IconCaretDown } from './styles';
import { WORKSPACE_LIST } from './graphql';

// DO NOT put this inside of the component, it MUST STAY OUTSIDE
const CustomAsyncPaginate = withAsyncPaginate(Select);
const { SingleValue } = components;

const defaultStyles = {
  fontSize: '14px',
  fontFamily: 'Roboto',
  color: '#4D5473',
};

const workspaceCreateStyles = {
  fontSize: '14px',
  fontFamily: 'Roboto',
  color: '#477AE9',
};

// docs styling https://react-select.com/styles
// check more in this file: react-select/dist/declarations/src/styles.d.ts
const customStyles = {
  option: (styles, { data }) => {
    const currentStyle = data.id === 'addWorkspace' ? workspaceCreateStyles : defaultStyles;
    return {
      ...styles,
      ...currentStyle,
    };
  },
  singleValue: (styles) => ({
    ...styles,
    ...defaultStyles,
    fontWeight: '500',
  }),
  input: (styles) => ({
    ...styles,
    ...defaultStyles,
  }),
  placeholder: (styles) => ({
    ...styles,
    ...defaultStyles,
  }),
};

const WorkspaceDropdown = (props) => {
  const {
    handleCompanyChange,
    company,
  } = props;

  const [value, setValue] = useState(company);
  const LIMIT = 50;

  const onChange = (newValue) => {
    setValue(newValue);
    handleCompanyChange(newValue.id);
  };

  // only tracking company.name; other properties are irrelevant
  useEffect(() => {
    if (company) {
      setValue(company);
    }
  }, [company?.name]);

  const loadOptions = async (search, loadedOptions) => {
    const offset = loadedOptions.length || 0;
    const { data } = await client.getClient().query({
      query: WORKSPACE_LIST,
      variables: {
        limit: LIMIT,
        offset,
        search,
      },
      fetchPolicy: 'no-cache',
    });

    if (data.workspaceList.totalCount !== LIMIT) {
      data.workspaceList.companies.push({
        id: 'addWorkspace',
        name: 'Create workspace',
      });
    }

    return {
      options: data.workspaceList.companies,
      hasMore: data.workspaceList.totalCount === LIMIT,
    };
  };

  const DropdownIndicator = () => null;

  return (
    <Container>
      <CustomAsyncPaginate
        noOptionsMessage={() => <TextNoResults>No results found</TextNoResults>}
        styles={customStyles}
        SelectComponent={Select}
        value={value}
        loadOptions={loadOptions}
        onChange={onChange}
        getOptionValue={(option) => option.id}
        getOptionLabel={(option) => option.name}
        appearance="none"
        // beautify the dropdown
        components={{
          SingleValue: (propsSingleValue) => (
            // eslint-disable-next-line react/jsx-props-no-spreading
            <SingleValue {...propsSingleValue}>
              {propsSingleValue.children}
              {value && <IconCaretDown name="caret down" size="small" />}
            </SingleValue>
          ),
          DropdownIndicator,
        }}
      />
    </Container>
  );
};

WorkspaceDropdown.propTypes = {
  handleCompanyChange: PropTypes.func.isRequired,
  company: PropTypes.shape.isRequired,
};

const mapStateToProps = ({ authentication }) => ({
  company: authentication.company,
});

export default connect(mapStateToProps, null)(WorkspaceDropdown);
